import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import * as React from 'react'

import CommentPopup from '../../../../common/CommentPopup/CommentPopup'

import CommentIcon from './CommentIcon/CommentIcon'

import styles from './EnableAgentForm.css'

type Props = {
  enabled?: boolean
  commentText: string | null | undefined
  commentTimestamp: string | null | undefined
  commentUser: string | null | undefined
  anchor: React.ReactNode | null | undefined
  iconClassName?: string
}

function EnableComment(props: Props) {
  const {enabled, commentText, commentUser, commentTimestamp, anchor, iconClassName} = props
  return (
    <CommentPopup
      anchor={
        <React.Fragment>
          <CommentIcon className={classNames(styles.commentIcon, iconClassName)} />
          {anchor}
        </React.Fragment>
      }
      actionTitle={enabled ? 'Enabled' : 'Disabled'}
      timestamp={commentTimestamp}
      user={commentUser}
      text={commentText}
      top={-4}
      left={-24}
      directions={[
        Directions.TOP_RIGHT,
        Directions.BOTTOM_RIGHT,
        Directions.TOP_LEFT,
        Directions.BOTTOM_LEFT,
      ]}
    />
  )
}

export default EnableComment
